import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';
import { store } from '../store';
import { hideLoading, showLoading } from '../actions';

function* participateCommitOption(action) {
  let response = null;
  const showGeneralPopup = false;
  store.dispatch(showLoading());
  try {
    response = yield call(
      requestAPI,
      API.API_PARTICIPATE_COMMIT_OPTION,
      API.POST,
      action.params,
      showGeneralPopup
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.PARTICIPATE_COMMIT_OPTION_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({
        type: types.PARTICIPATE_COMMIT_OPTION_FAILED,
        error: response
      });
    }
    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.PARTICIPATE_COMMIT_OPTION_FAILED, error });
  }
  store.dispatch(hideLoading());
}

export function* watchParticipateCommitOptionSaga() {
  yield takeLatest(
    types.PARTICIPATE_COMMIT_OPTION_REQUEST,
    participateCommitOption
  );
}
